import { JsonObject, JsonProperty } from 'json2typescript';
import { Moment } from 'moment';

import { DateAdapter } from '../../client/helpers/serializer/adapters/date.adapter';
import {
    PBCActivityInterface,
    PBCAddressInterface,
    PBCAliasInterface,
    PBCBirthDateInterface,
    PBCDetectionInterface,
    PBCDocumentInterface,
    PBCPenaltyInterface,
    PBCRelationInterface,
} from '../../../core';
import { PBCActivity } from './pbc-activity';
import { PBCAddress } from './pbc-address';
import { PBCAlias } from './pbc-alias';
import { PBCBirthdate } from './pbc-birthdate';
import { PBCDocument } from './pbc-document';
import { PBCPenalty } from './pbc-penalty';
import { PBCRelation } from './pbc-relation';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCDetection')
export class PBCDetection implements PBCDetectionInterface {
    @JsonProperty('actividades', [PBCActivity])
    private _activities: PBCActivityInterface[] = [];

    @JsonProperty('direcciones', [PBCAddress])
    private _addresses: PBCAddressInterface[] = [];

    @JsonProperty('aliases', [PBCAlias])
    private _aliases: PBCAliasInterface[] = [];

    @JsonProperty('fechasNacimiento', [PBCBirthdate])
    private _birthDates: PBCBirthDateInterface[] = [];

    @JsonProperty('comentarios', StringAdapter, true)
    private _comment?: string = undefined;

    @JsonProperty('nivelConfianza', StringAdapter)
    private _confidenceLevel: string = undefined;

    @JsonProperty('fecha', DateAdapter)
    private _date: Moment = undefined;

    @JsonProperty('documentosIdentificacion', [PBCDocument])
    private _documents: PBCDocumentInterface[] = [];

    @JsonProperty('nombreCompleto', StringAdapter)
    private _fullName: string = undefined;

    @JsonProperty('tipoLista', StringAdapter)
    private _listType: string = undefined;

    @JsonProperty('nombre', StringAdapter)
    private _name: string = undefined;

    @JsonProperty('sanciones', [PBCPenalty])
    private _penalties: PBCPenaltyInterface[] = [];

    @JsonProperty('tituloPersona', StringAdapter)
    private _personTitle: string = undefined;

    @JsonProperty('tipoPersona', StringAdapter)
    private _personType: string = undefined;

    @JsonProperty('programa', StringAdapter, true)
    private _program?: string = undefined;

    @JsonProperty('CategoriasPRP', StringAdapter)
    private _prpCategories: string[] = [];

    @JsonProperty('TipoPRP', StringAdapter)
    private _prpType: string = undefined;

    @JsonProperty('relaciones', [PBCRelation])
    private _relations: PBCRelationInterface[] = [];

    @JsonProperty('fuentes', StringAdapter)
    private _sources: string[] = [];

    @JsonProperty('estado', StringAdapter)
    private _status: string = undefined;

    @JsonProperty('fechaActualizacion', DateAdapter)
    private _updatedAt: Moment = undefined;

    get activities(): PBCActivityInterface[] {
        return this._activities;
    }

    get addresses(): PBCAddressInterface[] {
        return this._addresses;
    }

    get address(): PBCAddressInterface {
        return this._addresses.length > 0 ? this._addresses[0] : undefined;
    }

    get aliases(): PBCAliasInterface[] {
        return this._aliases;
    }

    get alias(): PBCAliasInterface {
        return this._aliases.length > 0 ? this._aliases[0] : undefined;
    }

    get birthDates(): PBCBirthDateInterface[] {
        return this._birthDates;
    }

    get comment(): string {
        return this._comment;
    }

    get confidenceLevel(): string {
        return this._confidenceLevel;
    }

    get date(): Moment {
        return this._date;
    }

    get documents(): PBCDocumentInterface[] {
        return this._documents;
    }

    get document(): PBCDocumentInterface {
        return this._documents.length > 0 ? this._documents[0] : undefined;
    }

    get fullName(): string {
        return this._fullName;
    }

    get listType(): string {
        return this._listType;
    }

    get name(): string {
        return this._name;
    }

    get penalties(): PBCPenaltyInterface[] {
        return this._penalties;
    }

    get personTitle(): string {
        return this._personTitle;
    }

    get personType(): string {
        return this._personType;
    }

    get program(): string {
        return this._program;
    }

    get prpCategories(): string[] {
        return this._prpCategories;
    }

    get prpCategory(): string {
        return this._prpCategories.length > 0 ? this._prpCategories[0] : undefined;
    }

    get prpType(): string {
        return this._prpType;
    }

    get relations(): PBCRelationInterface[] {
        return this._relations;
    }

    get sources(): string[] {
        return this._sources;
    }

    get status(): string {
        return this._status;
    }

    get updatedAt(): Moment {
        return this._updatedAt;
    }
}
